import { useState, useRef } from "react";
import { Volume2, Square } from "lucide-react";

/** Bouton "🔊 Écouter la Réponse" — Text-to-Speech via Web Speech API (WCAG AAA). */
export function TTSButton({ getText, label = "Écouter la réponse" }) {
  const [playing, setPlaying] = useState(false);
  const utterRef = useRef(null);

  const toggle = () => {
    if (playing) {
      window.speechSynthesis.cancel();
      setPlaying(false);
      return;
    }
    const text = typeof getText === "function" ? getText() : getText;
    if (!text || !("speechSynthesis" in window)) {
      alert("Synthèse vocale non supportée par ce navigateur.");
      return;
    }
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "fr-FR";
    u.rate = 0.98;
    u.onend = () => setPlaying(false);
    u.onerror = () => setPlaying(false);
    utterRef.current = u;
    window.speechSynthesis.speak(u);
    // Vibration haptique confirmant l'action (WCAG AAA)
    if (navigator.vibrate) navigator.vibrate([50, 30, 50]);
    setPlaying(true);
  };

  return (
    <button
      onClick={toggle}
      className="btn-ghost"
      data-testid="tts-btn"
      aria-label={playing ? "Arrêter la lecture" : label}
      aria-pressed={playing}
    >
      {playing ? <Square className="w-4 h-4" aria-hidden="true" /> : <Volume2 className="w-4 h-4" aria-hidden="true" />}
      {playing ? "Arrêter" : "🔊 " + label}
    </button>
  );
}
